import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";
import { data } from "../data";
import { Dropdown } from "./helpers/constants";

import { onChange } from "./helpers/on-change"

const DEFAULT_HORIZONTAL_ALIGN: string = "properties.styles.$deviceType.alignX";
const DEFAULT_VERTICAL_ALIGN: string = "properties.styles.$deviceType.alignY";

type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

export const Horizontal = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useState(defaultValue);
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = data.alignX.find(item => item.value === getValue(component, DEFAULT_HORIZONTAL_ALIGN.split("."), deviceType))?.label ?? data.alignX[0].label;
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_HORIZONTAL_ALIGN.split("."), deviceType)]);

  return (
    <div className="panel-div">
      <label
        htmlFor="horizontal"
        className="panel-label"
      >
        {label}
      </label>
      <Dropdown
        cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
        disabled={!isCheckedIn}
        options={
          data.alignX
            ? data.alignX.map((el) => ({
              name: el.label,
            }))
            : []
        }
        selected={{ name: value as string }}
        onChange={(option) => {
          if (data.alignX) {
            const item = data.alignX.find(item => item.label === option.name)
            if (item) {
              const value = item.value
              setValue(value)
              onChange({
                path: DEFAULT_HORIZONTAL_ALIGN,
                value,
                oldValue,
                setOldValue,
                selectedElementId
              })
            }
          }
        }}
      />
    </div>
  )
};
export const Vertical = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useState(defaultValue);
  const component = components[selectedElementId];

  useEffect(() => {
    if (component) {
      const previousValue = data.alignY.find(item => item.value === getValue(component, DEFAULT_VERTICAL_ALIGN.split("."), deviceType))?.label ?? data.alignY[0].label;
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_VERTICAL_ALIGN.split("."), deviceType)]);

  return (
    <div className="panel-div">
      <label
        className="panel-label"
        htmlFor="horizontal"
      >
        {label}
      </label>
      <Dropdown
        cursorStyle={!isCheckedIn ? "not-allowed" : "auto"}
        disabled={!isCheckedIn}
        options={
          data.alignY
            ? data.alignY.map((el) => ({
              name: el.label,
            }))
            : []
        }
        selected={{ name: value as string }}
        onChange={(option) => {
          if (data.alignY) {
            const item = data.alignY.find(item => item.label === option.name)
            if (item) {
              const value = item.value
              setValue(value)
              onChange({
                path: DEFAULT_VERTICAL_ALIGN,
                value,
                oldValue,
                setOldValue,
                selectedElementId
              })
            }
          }
        }}
      />
    </div>
  )
};
